import type { ApiProblemDetails } from "Infrastructure/Api/Api";
import { Resources } from "Translations/Resources";

/**
 * The save-time residence guard reports on Addresses — a person acting for a company can be edited
 * from several forms, and a generic failure would leave the user guessing what to fill in.
 */
export const getPartySaveErrorResource = (
  error: unknown,
  fallbackResource: string,
) => {
  const apiErrors = (error as { data?: ApiProblemDetails })?.data?.errors;

  return apiErrors && "Addresses" in apiErrors
    ? Resources.Validation.ResidenceRequired
    : fallbackResource;
};
